import React from 'react';
import PropTypes from 'prop-types';
import {
  optionProps,
  segmentProps,
} from 'components/molecules/Filter';
import FilterButton from 'components/molecules/FilterButton';
import FilterTags from 'components/molecules/FilterTags';

const propTypes = {
  filterOpen: PropTypes.bool.isRequired,
  filterOptions: PropTypes.arrayOf(optionProps).isRequired,
  filters: PropTypes.objectOf(
    PropTypes.arrayOf(optionProps),
  ).isRequired,
  onClose: PropTypes.func.isRequired,
  onFilterChange: PropTypes.func.isRequired,
  onOpen: PropTypes.func.isRequired,
  segments: PropTypes.arrayOf(segmentProps).isRequired,
};

function FilterWithTags({
  filterOpen,
  filterOptions,
  segments,
  filters,
  onFilterChange,
  onClose,
  onOpen,
}) {
  return (
    <div className="u-flexRow u-gap-8 u-alignCenter">
      <FilterButton
        isOpen={filterOpen}
        options={filterOptions}
        segments={segments}
        selections={filters}
        onClose={onClose}
        onOpen={onOpen}
        onSelectionsChange={onFilterChange}
      />
      <FilterTags
        dimensions={segments}
        selections={filters}
        onClick={onOpen}
        onRemove={(newFilters) => onFilterChange(newFilters)}
      />
    </div>
  );
}

FilterWithTags.propTypes = propTypes;

export default FilterWithTags;
